export const languages = [
  {
    id: "English",
    text: "Thanks",
    progress: 65,
  },
  {
    id: "Hindi",
    text: "धन्यवाद",
    progress: 100,
  }
];